import router from "@/router";
import nativeHandlerService from "@/services/nativeHandler";

export const goToBooking1 = () => {
  if (process.env.NODE_ENV == "local") {
    router.push({
      name: "MfittBooking1",
    });
  } else {
    nativeHandlerService.openTicket(
      `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}mfitt/booking1`
    );
  }
};
